import { __assign } from "tslib";
import React from 'react';
import JournalThumbHtmlView from './JournalHtml';
import JournalThumbReactView from './Journal';
var JournalThumbView = function (props) {
    if (props.isHtml) {
        return React.createElement(JournalThumbHtmlView, __assign({}, props));
    }
    return React.createElement(JournalThumbReactView, __assign({}, props));
};
JournalThumbView.displayName = 'JournalThumbView';
export default JournalThumbView;
//# sourceMappingURL=index.js.map